import { WorkspaceTwilioSettingsRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/settings/actions/twilio')({
  component: WorkspaceTwilioSettingsRoute,
});
